// Copy shared by every page: the header and footer chrome.
// docs/refresh/COPY_DECK.md "Global".

export const footer = {
  tagline: 'The secure virtual data room for every M&A deal you run.',
};
